<template>
  <form
    novalidate
    v-on:submit.stop.prevent="onSubmit"
  >
    <div
      v-for="(el, index) in schema"
      :key="index"
    >
      <RfpFieldMultiSelect
        v-if="el.field_id === FieldGroupTypes.LOCATIONS"
        v-model:modelValue="theModel.selectedLocations"
        :label="$t('Location - Hotel Name')"
        :options="el.locations"
      />

      <RfpFieldInput
        v-else-if="el.field_id === FieldGroupTypes.EVENT_NAME"
        v-model:modelValue="theModel.eventName"
        :name="$t('Event Name')"
        :isMandatory="el.is_mandatory"
      />

      <RfpGroupEventType
        v-else-if="el.field_id === FieldGroupTypes.EVENT_TYPE"
        v-model:type="theModel.eventType"
        v-model:nbAttendees="theModel.nbAttendees"
        :labelType="el.label_type || $t('Event Type')"
        :labelNbAttendees="el.label_nb_attendees || $t('# of Attendees')"
        :options="el.event_types"
        :isMandatoryEventType="el.is_mandatory_event_type"
        :isMandatoryNbAttendees="el.is_mandatory_nb_attendees"
      />

      <RfpGroupStartDate
        v-else-if="el.field_id === FieldGroupTypes.START_DATE"
        v-model:date="theModel.startDate"
        v-model:nbDays="theModel.nbDays"
        v-model:alternativeDate1="theModel.alternativeDate1"
        v-model:alternativeDate2="theModel.alternativeDate2"
        :labelDate="el.label_date || $t('Start Date')"
        :labelNbDays="el.label_nb_days || $t('# of Days')"
        :labelAlternativeDates="$t('Alternate Start Date')"
        :labelAddAlternativeDates="$t('Add Alternate Start Date')"
        :labelRemoveAlternativeDates="$t('Remove Alternate Start Date')"
        :isMandatoryStartDate="el.is_mandatory_start_date"
        :showNbDays="el.show_nb_days"
        :isMandatoryNbDays="el.is_mandatory_nb_days"
        :nbAlternativeDates="el.nb_alternative_dates"
      />

      <RfpGroupBudget
        v-else-if="el.field_id === FieldGroupTypes.BUDGET"
        v-model:totalBudget="theModel.totalBudget"
        v-model:currency="theModel.currency"
        v-model:promocode="theModel.promocode"
        :labelTotalBudget="el.label_total_budget || $t('Total Budget')"
        :labelCurrency="el.label_currency || $t('Currency')"
        :labelPromocode="$t('Promocode')"
        :labelAddPromocode="$t('Add Promocode')"
        :labelRemovePromocode="$t('Remove Promocode')"
        :options="el.currencies"
        :isMandatory="el.is_mandatory"
        :isMandatoryCurrency="el.is_mandatory_currency"
        :showPromocode="el.show_promocode"
      />

      <RfpGroupRoomSetup
        v-else-if="el.field_id === FieldGroupTypes.ROOM_SETUP"
        v-model:modelValue="theModel.roomSetup"
        :labelRoomSetup="el.label || $t('Room Setup')"
        :checkbox="el.function_room_types"
        :isMandatory="el.is_mandatory"
      />

      <RfpGroupAddEvents
        v-else-if="el.field_id === FieldGroupTypes.ADD_EVENTS"
        v-model:modelValue="theModel.addEvent"
        :labelAddEvent="el.label || $t('Would you like adding events?')"
        :events="el.events"
        :isMandatory="el.is_mandatory"
      />

      <RfpGroupGuestRooms
        v-else-if="el.field_id === FieldGroupTypes.GUEST_ROOMS"
        v-model:enable-guest-rooms="theModel.guestRoomsEnabled"
        v-model:checkIn="theModel.guestRoomsCheckIn"
        v-model:nbNights="theModel.guestRoomsNbNights"
        v-model:nbRooms="theModel.guestRoomsNbRooms"
        v-model:alternativeCheckIn1="theModel.guestRoomsAlternativeCheckIn1"
        v-model:alternativeCheckIn2="theModel.guestRoomsAlternativeCheckIn2"
        v-model:request="theModel.guestRoomsRequest"
        :label="el.label || $t('Guest rooms?')"
        :labelCheckIn="el.label_check_in || $t('Check-in date')"
        :labelNbNights="el.label_nb_nights || $t('# of Nights')"
        :labelNbRooms="el.label_nb_rooms || $t('# of Rooms')"
        :labelAlternativeCheckIn="$t('Alternate Check-In Date')"
        :labelAddAlternativeCheckIn="$t('Add Alternate Check-In Date')"
        :labelRemoveAlternativeCheckIn="$t('Remove Alternate Check-In Date')"
        :labelRequest="el.label_request || $t('Guest rooms requests')"
        :showGuestRequest="el.show_guest_request"
        :nbAlternativeDates="el.nb_alternative_dates"
      />

      <RfpFieldTextarea
        v-else-if="el.field_id === FieldGroupTypes.OTHER_REQUEST"
        v-model:modelValue="theModel.otherRequest"
        :label="el.label || $t('Any other request for your event?')"
        :isMandatory="el.is_mandatory"
      />

      <template v-else-if="el.field_id === FieldGroupTypes.ADDITIONAL_INFORMATION">
        <RfpFieldTextarea
          v-if="el.field_type === 'textarea'"
          :model-value="getAdditionalInformation(`${index}`)"
          @update:model-value="
            (newValue) =>
              setAdditionalInformation(
                `${index}`,
                el.label || $t('Additional information'),
                newValue,
              )
          "
          :label="el.label || $t('Additional information')"
          :isMandatory="el.is_mandatory"
        />

        <RfpFieldInput
          v-else
          :model-value="getAdditionalInformation(`${index}`)"
          @update:model-value="
            (newValue) =>
              setAdditionalInformation(
                `${index}`,
                el.label || $t('Additional information'),
                newValue,
              )
          "
          :name="el.label || $t('Additional information')"
          :isMandatory="el.is_mandatory"
        />
      </template>

      <RfpFieldSelect
        v-else-if="el.field_id === FieldGroupTypes.ADDITIONAL_INFORMATION_DROPDOWN"
        :model-value="getAdditionalInformation(`${index}`)"
        @update:model-value="
          (newValue) =>
            setAdditionalInformation(`${index}`, el.label || $t('Additional information'), newValue)
        "
        :label="el.label || $t('Additional information')"
        :isMandatory="el.is_mandatory"
        :options="el.dropdown_options"
      />

      <RfpFieldPreferredTime
        v-else-if="el.field_id === FieldGroupTypes.ADDITIONAL_INFORMATION_PREFERRED_TIME"
        :startTime="getAdditionalInformation(`${index}-start`)"
        :endTime="getAdditionalInformation(`${index}-end`)"
        @update:startTime="
          (newValue) =>
            setAdditionalInformation(
              `${index}-start`,
              el.label_start_time || $t('Preferred Start Time'),
              newValue,
            )
        "
        @update:endTime="
          (newValue) =>
            setAdditionalInformation(
              `${index}-end`,
              el.label_end_time || $t('Preferred End Time'),
              newValue,
            )
        "
        :labelStartTime="el.label_start_time || $t('Preferred Start Time')"
        :labelEndTime="el.label_end_time || $t('Preferred End Time')"
        :isMandatoryStartTime="el.is_mandatory_start_time"
        :isMandatoryEndTime="el.is_mandatory_end_time"
      />

      <RfpFieldInput
        v-else-if="el.field_id === FieldGroupTypes.COMPANY_NAME"
        v-model:modelValue="theModel.companyName"
        :name="el.label || $t('Company name')"
        :isMandatory="el.is_mandatory"
      />

      <RfpGroupContactInfo
        v-else-if="el.field_id === FieldGroupTypes.CONTACT_INFORMATION"
        v-model:contactFirstname="theModel.contactFirstname"
        v-model:contactLastname="theModel.contactLastname"
        v-model:contactEmail="theModel.contactEmail"
        v-model:contactPhone="theModel.contactPhone"
        :labelContactFirstname="el.label_contact_firstname || $t('First Name')"
        :labelContactLastname="el.label_contact_lastname || $t('Last Name')"
        :labelContactEmail="el.label_contact_email || $t('E-mail')"
        :labelContactPhone="el.label_contact_phone || $t('Phone Number')"
        :isMandatoryFirstname="el.is_mandatory_first_name"
        :isMandatoryLastname="el.is_mandatory_last_name"
        :isMandatoryEmail="el.is_mandatory_email"
        :isMandatoryPhone="el.is_mandatory_phone_number"
      />

      <RfpGroupPostalInfo
        v-else-if="el.field_id === FieldGroupTypes.POSTAL_INFORMATION"
        v-model:postalAddress="theModel.address"
        v-model:postalCityRegion="theModel.cityRegion"
        v-model:postalState="theModel.state"
        v-model:postalZipCode="theModel.zipcode"
        v-model:postalCountry="theModel.countryCode"
        :labelPostalAddress="el.label_postal_address || $t('Address')"
        :labelPostalCityRegion="el.label_postal_city_region || $t('City/Region')"
        :labelPostalState="el.label_postal_state || $t('State')"
        :labelPostalZipCode="el.label_postal_zip_code || $t('Zip Code')"
        :labelPostalCountryCode="el.label_postal_country_code || $t('Country')"
        :isMandatoryAddress="el.is_mandatory_address"
        :isMandatoryCityRegion="el.is_mandatory_city_region"
        :isMandatoryState="el.is_mandatory_state"
        :isMandatoryZipCode="el.is_mandatory_zip_code"
        :isMandatoryCountryCode="el.is_mandatory_country"
        :show-section-address="el.show_section_address"
        :show-section-zip-code="el.show_section_zipcode"
        :show-section-country="el.show_section_country"
      />

      <RfpFieldDate
        v-else-if="el.field_id === FieldGroupTypes.NEED_REQUEST_BY"
        v-model:modelValue="theModel.needRequestBy"
        :label="el.label || $t('Need response by:')"
        :isMandatory="el.is_mandatory"
      />

      <RfpFieldAttachment
        v-else-if="el.field_id === FieldGroupTypes.ATTACHMENTS"
        :label="el.label || $t('Add documents')"
        v-model="theModel.attachments"
      />

      <RfpFieldCheck
        v-else-if="el.field_id === FieldGroupTypes.ACCEPT_TERMS"
        v-model:modelValue="theModel.acceptedTerms"
        class="db-tw-mb-9"
        :isMandatory="true"
        :name="el.label"
      />

      <RfpFieldTitleSection
        v-else-if="el.field_id === FieldGroupTypes.TITLE_SECTION"
        class="db-tw-mb-9"
        :label="el.label"
        :isFirstFormElement="index === 0"
      />
    </div>

    <button
      type="submit"
      class="db-tw-w-full db-tw-mt-10 md:db-tw-w-1/2 md:db-tw-mt-4 db-button-large db-button-primary"
    >
      {{ buttonText }}
    </button>
  </form>
</template>
<script lang="ts" setup>
import { computed, watch } from 'vue'
import { useVuelidate } from '@vuelidate/core'

import { FieldGroupTypes } from '@/features/RfpForm/types/FieldGroupTypes'
import type { RfpFieldGroup } from '@/features/RfpForm/types/RfpFields'
import type { RfpFormData } from '@/features/RfpForm/types/RfpFormData'

import { useScrollToElement } from '@/features/RfpForm/composables/useRfpForm'

const props = defineProps<{
  stepNumber: number
  modelValue: RfpFormData
  schema: RfpFieldGroup[]
  buttonText: string
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', modelValue: RfpFormData): void
  (e: 'update:validation', isFormCorrect: boolean): void
  (e: 'update:submit'): void
}>()

const theModel = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value),
})

/**
 * Validation object
 */
const v$ = useVuelidate()

/**
 * @function - onSubmit
 * Check if the current form fields are valid
 */
async function onSubmit() {
  v$.value.$touch()
  const isFormCorrect = await v$.value.$validate()
  if (isFormCorrect) {
    emit('update:submit')
  } else {
    /* Validation is not ok - Scroll To error */
    useScrollToElement('.db-has-error')
  }
}

/**
 * @watch formIsInvalid
 * @params newValue
 * Emit validation event - when form is invalid - to update stepper
 */
const formIsInvalid = computed(() => {
  return v$.value.$invalid
})

watch(formIsInvalid, (newValue) => {
  emit('update:validation', newValue)
})

function getAdditionalInformation(fieldIndex: string): string {
  const fieldKey = `${props.stepNumber}-${fieldIndex}`
  return theModel.value.additionalInformations?.get(fieldKey)?.value || ''
}

function setAdditionalInformation(fieldIndex: string, label: string, value: string | number) {
  const fieldKey = `${props.stepNumber}-${fieldIndex}`
  if (typeof theModel.value.additionalInformations === 'undefined') {
    theModel.value.additionalInformations = new Map()
  }
  theModel.value.additionalInformations.set(fieldKey, {
    label,
    value: String(value),
  })
}
</script>
